import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterValueToSetStatus } from "../../../../form/utils";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [
                "rows",
                "editable",
                "importable",
                "exportable",
                "importFormRelevanceForm",
                "showTotal",
                "showAllEdit",
                "sheetFiters",
                "mobileDisplayMode",
            ],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name, { options: {
                //对子表的options进行重写，其名称最大长度只支持到50
                regexps: {
                    required: i18n.t('dataitem.ValidityErrTips7').toString(),
                    maxLength: {
                        len: 50,
                        message: i18n.t('dataitem.ValidityErrTips8').toString(),
                    },
                    regexps: [
                        {
                            regexp: /^[^ ]/,
                            message: i18n.t('dataitem.ValidityErrTips9').toString(),
                        },
                    ],
                },
            } }),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.Sheet').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.Sheet').toString() }),
        width: {
            options: {
                regexps: {
                    required: i18n.t('dataitem.ValidityErrTips10').toString(),
                    regexps: [
                        {
                            regexp: /^[1-9]\d*$/,
                            message: i18n.t('dataitem.ValidityErrTips2').toString(),
                        },
                        {
                            regexp: (value) => parseFloat(value) <= 885,
                            message: i18n.t('dataitem.ValidityErrTips11').toString(),
                        },
                        {
                            regexp: (value) => parseFloat(value) >= 10,
                            message: i18n.t('dataitem.ValidityErrTips12').toString(),
                        },
                    ],
                },
            },
        },
        // 默认行数
        rows: {
            options: {
                regexps: {
                    required: i18n.t('dataitem.ValidityErrTips13').toString(),
                    regexps: [
                        {
                            regexp: /^[0-9]\d*$/,
                            message: i18n.t('dataitem.ValidityErrTips2').toString(),
                        },
                        {
                            regexp: (value) => parseFloat(value) <= 100,
                            message: i18n.t('dataitem.ValidityErrTips14').toString(),
                        },
                    ],
                },
            },
        },
        editable: {
            options: {
                // disabled: true
                hideField: (value) => {
                    return !value ? ["importable"] : [];
                },
                callback: (key, attr, attrs, vm) => {
                    let { value } = attr;
                    vm.updateAttribute(key, "importable", value);
                },
            },
        },
        importFormRelevanceForm: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                dataList: (attr, attrs) => {
                    const list = [
                        {
                            value: "",
                            label: i18n.t('dataitem.SelectPlaceholder').toString(),
                        },
                    ];
                    if (attr.dataItem && attr.dataItem.properties) {
                        attr.dataItem.properties.forEach((res) => {
                            // 对于在数据项列表但是不在表单中的需要过滤掉
                            if (res.used && (res.type === 9 || res.type === 11)) {
                                const listItme = {
                                    value: res.code,
                                    label: res.name,
                                };
                                list.push(listItme);
                            }
                        });
                    }
                    return new Promise((resolve, reject) => {
                        resolve(list);
                    });
                },
            },
        },
        sheetFiters: {
            value: [],
            type: ControlAttributeType.Array,
            options: {
                dataList(attr, attrs) {
                    let list = [];
                    // 支持类型：短文本、日期、数值、选人控件、逻辑、关联表单
                    const type = [0, 1, 2, 3, 4, 5, 50, 51, 60, 61, 8, 80, 81];
                    if (attr.dataItem && attr.dataItem.properties) {
                        attr.dataItem.properties.forEach((res) => {
                            //在数据模型新建的数据项type可能为0或者2
                            if (res.type === 0 || res.formPropertyType === 0) {
                                list.push(res);
                            }
                            else if (type.includes(res.type || res.formPropertyType) && res.code !== 'sortKey') {
                                list.push(res);
                            }
                        });
                    }
                    return new Promise((resolve, reject) => {
                        resolve(list);
                    });
                },
            },
            label: i18n.t('dataitem.PopupField').toString(),
        },
        displayFormula: {
            inputMethod: ControlAttributeType.Modal,
            modalType: "showRule",
            inputComponent: () => import("../../../../form/src/common/components/required-condition.vue"),
            options: {
                formatter: formatterValueToSetStatus,
            },
        },
        mobileDisplayMode: {
            inputMethod: ControlAttributeType.Dropdown,
            options: {
                list: [
                    {
                        value: "waterfall",
                        label: i18n.t('dataitem.WaterFall').toString(),
                    },
                    {
                        value: "table",
                        label: i18n.t('dataitem.TwoDimensional').toString(),
                    },
                    {
                        value: "page",
                        label: i18n.t('dataitem.Pageing').toString(),
                    },
                ],
            },
        },
    },
};
